<template>
  <div class="box-btn-scroll-to-top" @click="handleScrollToTop()">
    <i class="fa fa-chevron-up"></i>
    <div>TOP</div>
  </div>
</template>

<script>
export default {
  methods: {
    handleScrollToTop () {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    }
  }
}
</script>

<style scoped>
.box-btn-scroll-to-top {
  padding-top: 8px;
  position: fixed;
  right: 10px;
  bottom: 10px;
  width: 55px;
  height: 55px;
  z-index: 100;
  background: #008cc6;
  color: #fff;
  font-weight: bold;
  text-align: center;
  border-radius: 4px;
  line-height: 1;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/ButtonScrollToTop.vue